<template>
  <section class="block--no-padding">
    <array
      :items=users
      :undisplayed="['password', 'salt', 'apiToken']"
      :labels="{'id': 'Id', 'email': 'Courriel', 'enabled': 'Actif', 'lastname' : 'Nom', 'firstname' : 'Prénom' }"/>
  </section>
</template>
<script>
import array from '@/components/array'

export default {
  name: 'liste',
  components: {
    array
  },
  data () {
    return {
      items: []
    }
  },
  computed: {
    users () {
      if (this.items.length) {
        return this.items.map(i => {
          return i
        })
      }
      return []
    }
  },
  mounted () {
    this.HTTP.get(`/api/users`).then(r => {
      this.items = r.data
    })
  }
}
</script>
